module.exports = __webpack_public_path__ + "static/media/wardrobe.ec0c827e.png";